export default __webpack_public_path__ + "static/media/Arrows of the Haunter in the Dark.99145af1.jpg";